import { createReducer } from './utils';
import {
  SEARCH_LOADING,
  SEARCH_SUCCESS,
  SEARCH_FAILURE,
  UPDATE_REPORT_PARAMETERS,
  SEARCH_FILTER_LIST,
  RESET_FILTER_LIST,
  RESET_SEARCH_LIST,
  RESTORE_SEARCH_LIST,
  SWITCH_VIEW,
  REPORT_OPTIONS_LOADING,
  REPORT_OPTIONS_SUCCESS,
  REPORT_OPTIONS_FAILURE,
} from './constants';
import { dispatchSnack } from './utils/snackbar';

const DEFAULT_PARAMETERS = {
  task_type: '',
  item: '',
  aisle: '',
  ean: '',
};

const defaultState = {
  loading: false,
  barcode: '',
  reportParameters: DEFAULT_PARAMETERS,
  results: [],
  resultsFilter: [],
  scanerSelected: true,
  errorMessage: null,
  reportOptions: [],
  reportOptionsLoading: false,
  reportOptionsFetchedStore: null,
};

// reducer

export const reducer = createReducer(defaultState, {
  [SEARCH_LOADING]: handleSearchLoading,
  [SEARCH_FAILURE]: handleSearchFailure,
  [SEARCH_SUCCESS]: handleSearchSuccess,
  [UPDATE_REPORT_PARAMETERS]: handleUpdateReportParameters,
  [SEARCH_FILTER_LIST]: handleSearchFilterList,
  [RESET_FILTER_LIST]: handleResetFilter,
  [RESET_SEARCH_LIST]: handleResetSearch,
  [RESTORE_SEARCH_LIST]: handleRestoreSearch,
  [SWITCH_VIEW]: handleSwitchView,
  [REPORT_OPTIONS_LOADING]: handleReportOptionsLoading,
  [REPORT_OPTIONS_SUCCESS]: handleReportOptionsSuccess,
  [REPORT_OPTIONS_FAILURE]: handleReportOptionsFailure,
});

function handleSearchLoading(state, action) {
  return {
    ...state,
    loading: true,
  };
}

function handleSearchFailure(state, { payload: { error } }) {
  return {
    ...state,
    loading: false,
    parameters: DEFAULT_PARAMETERS,
    errorMessage: error,
  };
}

function handleSearchSuccess(state, { payload: { response } }) {
  return {
    ...state,
    loading: false,
    results: response,
  };
}

function handleUpdateReportParameters(state, { payload: { parameters } }) {
  return {
    ...state,
    reportParameters: parameters,
  };
}

function handleSearchFilterList(state, { payload: { newList } }) {
  return {
    ...state,
    resultsFilter: newList,
  };
}

function handleResetFilter(state, action) {
  return {
    ...state,
    resultsFilter: [],
  };
}

function handleResetSearch(state, action) {
  return {
    ...state,
    results: [],
  };
}

function handleRestoreSearch(state, { payload: { results } }) {
  return {
    ...state,
    loading: false,
    results,
  };
}

function handleSwitchView(state, { payload: { selected } }) {
  return {
    ...state,
    scanerSelected: selected,
  };
}

// actions

export function searchProduct(key, value, { silent = false } = {}) {
  return async (dispatch, getState, { services: { dataSource, colors } }) => {
    dispatch({ type: SEARCH_LOADING });

    const {
      stores: { currentStore },
      search: { reportParameters },
    } = getState();

    let parameters = Object.assign({}, reportParameters);

    try {
      let requestParameters = {};
      requestParameters['store'] = currentStore;
      requestParameters[key] = value;

      const response = await dataSource.requestProductsSearch({
        parameters: requestParameters,
      });

      if (
        Object.keys(response).length === 0 &&
        response.constructor === Object
      ) {
        // Empty response
        dispatch({ type: SEARCH_SUCCESS, payload: { response: [] } });
        dispatch({ type: UPDATE_REPORT_PARAMETERS, payload: { parameters } });
        if (!silent) dispatchSnack(dispatch, 'bruno.products.empty', colors.getInfoColor());
        return [];
      } else {
        // Find one product
        parameters['item'] = response[0].item;
        parameters['ean'] = response[0].ean;

        dispatch({ type: SEARCH_SUCCESS, payload: { response } });
        dispatch({ type: UPDATE_REPORT_PARAMETERS, payload: { parameters } });
        if (!silent) dispatchSnack(dispatch, 'bruno.products.found', colors.getSuccessColor());
        return response;
      }
    } catch (error) {
      console.log('searchProduct error', error);
      dispatch({
        type: SEARCH_FAILURE,
        payload: { error },
      });
      dispatch({ type: SEARCH_SUCCESS, payload: { response: [] } });
      dispatch({
        type: UPDATE_REPORT_PARAMETERS,
        payload: { parameters: DEFAULT_PARAMETERS },
      });
      if (!silent) dispatchSnack(dispatch, 'bruno.products.empty', colors.getInfoColor());
      return [];
    }
  };
}

export function setReportParameters(key, value) {
  return async (dispatch, getState, { services: { } }) => {
    const {
      search: { reportParameters },
    } = getState();

    try {
      let parameters = Object.assign({}, reportParameters);
      parameters[key] = value;
      dispatch({ type: UPDATE_REPORT_PARAMETERS, payload: { parameters } });
    } catch (error) {
      dispatch({
        type: SEARCH_FAILURE,
        payload: { error },
      });
    }
  };
}

export function setSearchFilter(page) {
  return async (dispatch, getState, { services: { } }) => {
    const {
      search: { results },
      search: { resultsFilter },
    } = getState();

    try {
      const start = 10 * page;
      const end = 10 * (page + 1);

      const oldData = resultsFilter.slice();
      const newData = results.slice(start, end);
      const newList = oldData.concat(newData);

      dispatch({ type: SEARCH_FILTER_LIST, payload: { newList } });
    } catch (error) {
      console.log(error);
    }
  };
}

export function resetSearchFilter() {
  return async (dispatch, getState, { services: { } }) => {
    try {
      dispatch({ type: RESET_FILTER_LIST });
    } catch (error) {
      console.log(error);
    }
  };
}

export function resetSearch() {
  return async (dispatch, getState, { services: { } }) => {
    try {
      dispatch({ type: RESET_SEARCH_LIST });
    } catch (error) {
      console.log(error);
    }
  };
}

export function restoreSearch(results) {
  return async (dispatch) => {
    dispatch({ type: RESTORE_SEARCH_LIST, payload: { results: results || [] } });
  };
}

export function switchSelectedView() {
  return async (dispatch, getState, { services: { } }) => {
    const {
      search: { scanerSelected },
    } = getState();

    try {
      const selected = !scanerSelected;
      dispatch({ type: SWITCH_VIEW, payload: { selected } });
    } catch (error) {
      console.log(error);
    }
  };
}

function handleReportOptionsLoading(state) {
  return {
    ...state,
    reportOptionsLoading: true,
  };
}

function handleReportOptionsSuccess(state, { payload: { reportOptions, store } }) {
  return {
    ...state,
    reportOptions,
    reportOptionsLoading: false,
    reportOptionsFetchedStore: store,
  };
}

function handleReportOptionsFailure(state) {
  return {
    ...state,
    reportOptions: [],
    reportOptionsLoading: false,
    reportOptionsFetchedStore: null,
  };
}

export function fetchReportOptions(store) {
  return async (dispatch, _getState, { services: { dataSource } }) => {
    try {
      dispatch({ type: REPORT_OPTIONS_LOADING });
      const response = await dataSource.requestResourcesReportOptions({ store });
      const reportOptions = response && response.data
        ? response.data
        : Array.isArray(response) ? response : [];
      dispatch({ type: REPORT_OPTIONS_SUCCESS, payload: { reportOptions, store } });
    } catch (error) {
      console.log(error);
      dispatch({ type: REPORT_OPTIONS_FAILURE });
    }
  };
}
